import React, { useContext, useState } from 'react';
import {
  defaultClassData,
  defaultUser,
  UserContext,
  ClassDataContext,
  ReviewModeContext,
} from 'services/contexts';
import { IUser } from 'models/auth';
import { IClassData } from '../models/icardio';

export const UserProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [user, setUser] = useState<IUser>(defaultUser);

  return <UserContext.Provider value={{ user, setUser }}>{children}</UserContext.Provider>;
};

export const ClassDataProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [classData, setClassData] = useState<IClassData>(defaultClassData);

  return (
    <ClassDataContext.Provider value={{ classData, setClassData }}>
      {children}
    </ClassDataContext.Provider>
  );
};

export const ReviewModeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isReviewMode, setIsReviewMode] = useState(false);

  return (
    <ReviewModeContext.Provider value={{ isReviewMode, setIsReviewMode }}>
      {children}
    </ReviewModeContext.Provider>
  );
};

export const useReviewMode = () => useContext(ReviewModeContext);
